const cart = {
    isLoading: false,
    isRowLoading: {},
    list: {},
    userInput: {},
    detail: {
        DiscountTotal: 0,
        ShippingTotal: 0,
        TaxTotal: 0,
        SubTotal: 0,
        Total: 0,
        DiscountTitle: '',
        //TaxDataItems: [],     // deprecated
        TaxSummary: [],     // it is json, but we make it become an array
        HasTaxInclusive: false,
        InternalItemID: '',
    },
    currencyFormat: typeof window.currencyFormat != 'undefined' ? window.currencyFormat: '0,0.00',
    currencyDisplayCode: typeof window.currencyDisplayCode != 'undefined' ? window.currencyDisplayCode: 'AU$',
    locale: typeof window.locale != 'undefined' ? window.locale: 'en_AU',
    selectedCartNoteId: null,
};
const CartReducer = function(state = cart, action) {
    switch (action.type) {
        case 'TOGGLE_CART_LOADING': {
            return {
                ...state,
                isLoading: action.value,
            };
        }
        case 'TOGGLE_CART_ROW_LOADING': {
            return {
                ...state,
                isRowLoading: {
                    [action.key]: action.value,
                },
            };
        }
        case 'UPDATE_CART_QTY': {
            return {
                ...state,
                list: {
                    ...state.list,
                    [action.key]: {
                        ...state.list[action.key],
                        TotalUnitItems: action.quantity,
                    },
                },
            };
        }
        case 'UPDATE_CART_LIST': {
            return {
                ...state,
                list: {
                    ...state.list,
                    ...action.list,
                },
            };
        }
        case 'REPLACE_CART_LIST': {
            return {
                ...state,
                list: action.list,
            };
        }
        case 'UPDATE_CART_DETAIL': {
            return {
                ...state,
                detail: {
                    ...state.detail,
                    ...action.detail,
                },
            };
        }
        case 'UPDATE_CART_USER_INPUT': {
            return {
                ...state,
                userInput: {
                    ...state.userInput,
                    [action.id]: {
                        ...state.userInput[action.id],
                        [action.key]: action.value
                    },
                }
            };
        }
        case 'CLEAR_CART_USER_INPUT': {
            const { [action.key]: _, ...newUserInput } = state.userInput[action.id];

            return {
                ...state,
                userInput: {
                    ...state.userInput,
                    [action.id]: newUserInput,
                }
            };
        }
        case 'SELECT_EDIT_CART_NOTE': {
            return {
                ...state,
                selectedCartNoteId: action.value,
            };
        }
        default: {
            return state;
        }
    }
};

export default CartReducer;
